/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, the core F1 Fantasy tools — Apex Team, Budget Boost, Statistics, Standings, and Fantasy Points — are free with no account required. Some Tier A price predictions unlock after watching a short ad or with a Pro subscription, but you can use every tool's core features without paying.`)
};

const es_f1_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, las herramientas principales de F1 Fantasy — Apex Team, Budget Boost, Estadísticas, Clasificación y Puntos Fantasy — son gratuitas y no requieren cuenta. Algunas predicciones de precio de Nivel A se desbloquean viendo un anuncio corto o con una suscripción Pro, pero puedes usar las funciones principales de todas las herramientas sin pagar.`)
};

const de_f1_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, die zentralen F1-Fantasy-Werkzeuge — Apex-Team, Budget Boost, Statistiken, Tabelle und Fantasy-Punkte — sind kostenlos und ohne Konto nutzbar. Einige Tier-A-Preisprognosen schaltest du frei, indem du eine kurze Werbung ansiehst oder mit einem Pro-Abo, aber die Kernfunktionen jedes Werkzeugs kannst du ohne Bezahlung nutzen.`)
};

const nl_f1_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, de belangrijkste F1 Fantasy-tools — Apex Team, Budget Boost, Statistieken, Klassement en Fantasy-punten — zijn gratis en vereisen geen account. Sommige Tier A-prijsvoorspellingen worden ontgrendeld na het bekijken van een korte advertentie of met een Pro-abonnement, maar je kunt de kernfuncties van elke tool zonder te betalen gebruiken.`)
};

const fr_f1_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, les outils F1 Fantasy principaux — Équipe Apex, Boost Budget, Statistiques, Classement et Points Fantasy — sont gratuits, sans compte requis. Certaines prédictions de prix Tier A se débloquent après avoir regardé une courte publicité ou avec un abonnement Pro, mais vous pouvez utiliser les fonctionnalités principales de chaque outil sans payer.`)
};

const it_f1_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, gli strumenti F1 Fantasy principali — Team Apex, Budget Boost, Statistiche, Classifica e Punti Fantasy — sono gratuiti e non richiedono account. Alcune previsioni di prezzo Tier A si sbloccano dopo aver guardato una breve pubblicità o con un abbonamento Pro, ma puoi usare le funzionalità principali di ogni strumento senza pagare.`)
};

const pt_br2_f1_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, as ferramentas principais de F1 Fantasy — Equipe Apex, Impulso de Orçamento, Estatísticas, Classificação e Pontos Fantasy — são gratuitas, sem necessidade de conta. Algumas previsões de preço Tier A são desbloqueadas assistindo a um anúncio curto ou com uma assinatura Pro, mas você pode usar os recursos principais de todas as ferramentas sem pagar.`)
};

const pt_f1_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, as ferramentas principais de F1 Fantasy — Apex Team, Budget Boost, Estatísticas, Classificação e Pontos Fantasy — são gratuitas e sem necessidade de conta. Algumas previsões de preço Tier A desbloqueiam depois de assistir a um anúncio curto ou com uma subscrição Pro, mas pode usar as funcionalidades principais de todas as ferramentas sem pagar.`)
};

const ja_f1_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。Apexチーム、バジェットブースト、統計、順位表、ファンタジーポイントといった主要なF1ファンタジーツールは、アカウント不要で無料で利用できます。一部のティアA価格予測は短い広告視聴またはPro登録でアンロックされますが、各ツールの中心となる機能は無料で利用できます。`)
};

const zh_f1_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，核心的 F1 Fantasy 工具——Apex Team、Budget Boost、统计数据、积分榜和梦幻积分——都免费且无需注册账户。部分 Tier A 价格预测需要观看一段短广告或订阅 Pro 才能解锁，但每个工具的核心功能都无需付费即可使用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_faq2_a", locale)
	if (locale === "en") return en_f1_faq2_a(inputs)
	if (locale === "es") return es_f1_faq2_a(inputs)
	if (locale === "de") return de_f1_faq2_a(inputs)
	if (locale === "nl") return nl_f1_faq2_a(inputs)
	if (locale === "fr") return fr_f1_faq2_a(inputs)
	if (locale === "it") return it_f1_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_faq2_a(inputs)
	if (locale === "pt") return pt_f1_faq2_a(inputs)
	if (locale === "ja") return ja_f1_faq2_a(inputs)
	return zh_f1_faq2_a(inputs)
};